import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import ArrowCarousel from "../svg/arrowCarousel"
import Card from "../card/card"
import "./carousel.scss"

const mapCardsToSlides = (cards, slideSize) => {
  return cards.reduce((acc, cur, index) => {
    const slideIndex = Math.floor((index) / slideSize)
    acc[slideIndex] = acc[slideIndex] ? acc[slideIndex] : []
    acc[slideIndex].push(cur)
    return acc
  }, [])
}

const Carousel = ({ cards }) => {
  const [active, setActive] = useState(0)
  const [isAnimationActive, setIsAnimationActive] = useState(true)
  const [slides] = useState(mapCardsToSlides(cards, 3))

  const slideTo = (index) => {
    if (index < 0) {
      setIsAnimationActive(false)
      setActive(slides.length)
      return
    }
    if (index > slides.length - 1) {
      setIsAnimationActive(false)
      setActive(-1)
      return
    }
    setActive(index)
  }

  const handleLeftArrowClick = () => {
    slideTo(active - 1)
  }

  const handleRightArrowClick = () => {
    slideTo(active + 1)
  }

  useEffect(() => {
    if (!isAnimationActive) {
      setIsAnimationActive(true)
      if (active >= slides.length) {
        setActive(slides.length - 1)
      }
      if (active < 0) {
        setActive(0)
      }
    }
  }, [isAnimationActive])
  return (
    <div className="carousel__wrapper">
      <article className="carousel">
        <div className="slider">
          <div
            className={"slide slide--virtual slide--virtual-left"}
            style={{
              transform: `translate3d(${(-1 - active) * 100}%, 0px, 0px)`,
              transition: isAnimationActive ? "all 450ms ease-out 0s" : null
            }}
          >
            {slides[slides.length - 1].map((card, ci) =>
              <Card
                key={ci}
                node={card}
              />
            )}
          </div>
          {slides.map((slideCards, si) =>
            <div
              key={si}
              className={active === si ? "slide" : "slide"}
              style={{
                transform: `translate3d(${(si - active) * 100}%, 0px, 0px)`,
                transition: isAnimationActive ? "all 450ms ease-out 0s" : null
              }}
            >
              {slideCards.map((card, ci) =>
                <Card
                  key={ci}
                  node={card}
                />
              )}
            </div>)
          }
          <div
            className={"slide slide--virtual slide--virtual-right"}
            style={{
              transform: `translate3d(${(slides.length - active) * 100}%, 0px, 0px)`,
              transition: isAnimationActive ? "all 450ms ease-out 0s" : null
            }}
          >
            {slides[0].map((card, ci) =>
              <Card
                key={ci}
                node={card}
              />
            )}
          </div>
        </div>
      </article>
      <button
        className="carousel__button carousel__button--left"
        onClick={handleLeftArrowClick}
      >
        <ArrowCarousel />
      </button>
      <button
        className="carousel__button carousel__button--right"
        onClick={handleRightArrowClick}
      >
        <ArrowCarousel className="carousel__arrow--right" />
      </button>
    </div>
  )
}

Carousel.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      surname: PropTypes.string,
      text: PropTypes.string,
      image: PropTypes.object
    })
  ).isRequired
}
export default Carousel
